import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/partners.jpg'
import _imports_1 from '../images/partners.png'


const _withScopeId = n => (_pushScopeId("data-v-147d2300"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "partners"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-con" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "PARTNERS")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "main-img",
  src: _imports_1,
  alt: "partners"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_BackTop = _resolveComponent("BackTop")!
  const _component_ChatBox = _resolveComponent("ChatBox")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_CookieBox = _resolveComponent("CookieBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar),
    _hoisted_2,
    _createVNode(_component_Breadcrumb),
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_BackTop),
    _createVNode(_component_ChatBox),
    _createVNode(_component_Footer),
    _createVNode(_component_CookieBox)
  ]))
}